import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Button } from "cxa-components";
import { uploadReceipt, setRejectedReceipt, skipOCRProcess } from "../../../actions/claimActionsPP";
import messages from "components/messagesDescription";
import ReceiptUploader from "../widgets/receipt-uploader";
import { ACCEPT_FILES, MAX_FILE_SIZE } from "../../constants";
import ReceiptProcessingLoader from "../ReceiptProcessingLoader";
import ClaimSubmissionFormPP from "../ClaimSubmissionFormPP";
import { Prompt } from "react-router-dom";

const OCRReceiptUploader = ({ data, params, props, intl, initialValues, defaultValues }) => {
  const dispatch = useDispatch();
  const skipOCR = () => {
    dispatch(skipOCRProcess());
  };

  return (
    <Fragment>
      {!data.receipt && !data.skipReceipt && (
        <Fragment>
          <div className="upload-receipt-container">
            {!data.isCameraStarted && (
              <ReceiptUploader
                className="receipt-uploader"
                accept={ACCEPT_FILES}
                maxSize={MAX_FILE_SIZE}
                onDrop={(files, rejectedFiles) => {
                  files.map(file => {
                    dispatch(uploadReceipt(file, params.selectedDelegator));
                  });
                  Array.isArray(rejectedFiles) &&
                    rejectedFiles.length > 0 &&
                    dispatch(setRejectedReceipt(rejectedFiles));
                }}
                {...props}
              />
            )}
          </div>
          {data.rejectedReceipt && data.rejectedReceipt.length > 0 && (
            <div className="field__error">
              <p>
                <strong>{intl.formatMessage(messages.uploadInvalidFileDescription)}</strong>
              </p>
              <p>
                <strong>{intl.formatMessage(messages.uploadImageLimitationDescription)}</strong>
              </p>
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "20px",
            }}
          >
            <Button type="button" secondary disabled>
              {intl.formatMessage(messages.claims.manualUploadReceipt)}
            </Button>
          </div>
          <Prompt message={intl.formatMessage(messages.claims.saveClaimInformationDescription)} />
        </Fragment>
      )}
      {data.receipt &&
        !data.skipReceipt &&
        (!data.ocrValues || data.ocrValues.status == "pending") &&
        !data.skipOCR && (
          <div>
            <ReceiptProcessingLoader receipt={data.receipt} intl={intl} {...props} />
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button type="button" secondary onClick={skipOCR}>
                {intl.formatMessage(messages.claims.manualUploadReceipt)}
              </Button>
            </div>
          </div>
        )}
      {((data.receipt &&
        ((data.ocrValues &&
          (data.ocrValues.status == "success" || data.ocrValues.status == "error")) ||
          data.skipOCR)) ||
        data.skipReceipt) && (
        <ClaimSubmissionFormPP {...props} initialValues={{ ...initialValues, ...defaultValues }} />
      )}
    </Fragment>
  );
};

OCRReceiptUploader.propTypes = {
  data: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  intl: PropTypes.object.isRequired,
  initialValues: PropTypes.object,
  defaultValues: PropTypes.object,
  props: PropTypes.object.isRequired,
  isNarrowScreen: PropTypes.bool,
};

export default OCRReceiptUploader;



// WEBPACK FOOTER //
// ./components/claim/widgets/OCRReceiptUploader.jsx